/**
 * Where the seam sits at each band, as a percentage of the page width.
 *
 * The line opens at dead centre — the two worlds in stalemate — and the record
 * briefly *wins* at the problem, which is the honest shape of the situation.
 * From there the counter takes ground section by section, down to a sliver at
 * the footer. The one return to centre is the manufacturer comparison, which
 * re-stages the two worlds deliberately, row against row.
 *
 * Each band animates from the previous entry to its own, so one band's end is
 * the next band's start and the line reads as continuous. Change a number here
 * and both the band and the diagonal above it follow.
 *
 * `footer` is where the line stops. The footer draws that last step itself,
 * since the page above it ends at the pilot.
 */
export const SEAM = {
  hero: 50,
  problem: 56,
  howItWorks: 44,
  app: 37,
  platform: 32,
  manufacturers: 50,
  retailers: 29,
  pilot: 16,
  footer: 7,
} as const;
